import getSvgIcon from '../../../helpers/getSvgIcon';
import Filter from '../../../controllers/filter';

const COLUMN_TEMPLATES_GENERATORS = {
  buttons: getButtonsTemplate,
};

function getButtonsTemplate(task, instance) {
  if (
    (task.$level === 0 && instance.config.isJira)
    || (task.$level === 0 && (instance.config.multiview || Filter.filterApplied))
    || task.$virtual
    || task.type === instance.config.types.button
  ) {
    return '';
  }

  const isMassChangeDisabled = !instance.ganttDataApi.isMassChangeEnabled();

  const optionsTemplate = isMassChangeDisabled
    ? `<div class='column-options'>
        <div class='column-options-cog icon-dots'>
          ${getSvgIcon('more-1', 'regular', 24)}
        </div>
      </div>`
    : '';

  if (isMassChangeDisabled) {
    const hidden = instance.ganttDataApi.getSpecialPasteIconId() === task.id ? '' : 'hidden';
    const height = `${instance.config.original_row_height - 2 - parseInt(instance.config.original_row_height / 10, 10)}px`;
    const heightContainer = `${parseInt(instance.config.original_row_height, 10) - 3}px`;

    const specialPasteTemplate = `
      <div style='height: ${heightContainer};' class='column-options special-paste-options ${hidden} tooltip-gantt' data-key='task_special_paste_tooltip' data-position='top'>
        <div class='column-options-cog special-paste-icon' style='height: ${height};'>${getSvgIcon('paste', 'regular', 24)}</div>
      </div>`;

    return specialPasteTemplate + optionsTemplate;
  }

  return optionsTemplate;
}

export function getTemplate(columnName, instance, task) {
  if (!COLUMN_TEMPLATES_GENERATORS[columnName]) {
    throw `Template function does not exist for column - ${columnName}`;
  }

  return COLUMN_TEMPLATES_GENERATORS[columnName](task, instance);
}
